/** Dashboard UI languages. English is the fallback. */
export const APP_LANGS = ['en', 'hy', 'ru'] as const;
export type AppLang = (typeof APP_LANGS)[number];

export const LANG_STORAGE_KEY = 'dashboard_lang';

export const LANG_OPTIONS: { code: AppLang; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'hy', label: 'ՀՅ' },
  { code: 'ru', label: 'RU' },
];

export function resolveAppLang(lang?: string | null): AppLang {
  const base = (lang ?? '').split('-')[0]?.toLowerCase();
  if (base === 'hy') return 'hy';
  if (base === 'ru') return 'ru';
  return 'en';
}

/** BCP 47 tag for dates, numbers, and region names. */
export function resolveAppLocale(lang?: string | null): string {
  const code = resolveAppLang(lang);
  if (code === 'hy') return 'hy-AM';
  if (code === 'ru') return 'ru-RU';
  return 'en-US';
}

export function formatAmd(
  n: number,
  lang?: string | null,
  opts?: Intl.NumberFormatOptions,
): string {
  return `${Number(n).toLocaleString(resolveAppLocale(lang), {
    maximumFractionDigits: 0,
    ...opts,
  })} ֏`;
}

export function formatNumber(
  n: number,
  lang?: string | null,
  opts?: Intl.NumberFormatOptions,
): string {
  return Number(n).toLocaleString(resolveAppLocale(lang), opts);
}

export function deepMerge<T extends Record<string, unknown>>(base: T, extra: Record<string, unknown>): T {
  const out: Record<string, unknown> = { ...base };
  for (const [key, value] of Object.entries(extra)) {
    const existing = out[key];
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      existing &&
      typeof existing === 'object' &&
      !Array.isArray(existing)
    ) {
      out[key] = deepMerge(existing as Record<string, unknown>, value as Record<string, unknown>);
    } else {
      out[key] = value;
    }
  }
  return out as T;
}
